module.exports = __webpack_public_path__ + "img/land-use.963756bc.svg";